import { useNavigate } from "react-router-dom";
import { logout } from "../../redux/auth/actions";
import { useEffect, useState } from "react";
import storePersist from "../../redux/storePersist";
import { selectCurrent } from "../../redux/settings/selectors";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../hooks/hooks";
import { settings } from "../../redux/settings/actions";
import { selectOrganizationUnitsListItems } from "../../redux/organizationUnits/selector";

const TransportAgentSidebar = () => {
	let items: any = []
	const result = useSelector(selectCurrent)
	const { sidebar, theme } = result
	const [color, setColor] = useState('universal')
	const [activeIndex, setActiveIndex] = useState(null);
	const [activeSubIndex, setActiveSubIndex] = useState(null);
	const navigate = useNavigate()
	const [logo, setLogo] = useState<any>()
	const organizationLists = useSelector(selectOrganizationUnitsListItems)
	const [open, setOpen] = useState(items)


	const [menus, setMenus] = useState([
		{
			id: `main-menu-2-all`,
			label: 'Dashboard',
			path: '/rap-agent/home',
			isEnabled: true,
			svg: (
				<svg className="h-5 w-5  mr-1"
					viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill-rule="evenodd" clip-rule="evenodd" d="M3.75 4.5L4.5 3.75H10.5L11.25 4.5V10.5L10.5 11.25H4.5L3.75 10.5V4.5ZM5.25 5.25V9.75H9.75V5.25H5.25ZM12.75 4.5L13.5 3.75H19.5L20.25 4.5V10.5L19.5 11.25H13.5L12.75 10.5V4.5ZM14.25 5.25V9.75H18.75V5.25H14.25ZM3.75 13.5L4.5 12.75H10.5L11.25 13.5V19.5L10.5 20.25H4.5L3.75 19.5V13.5ZM5.25 14.25V18.75H9.75V14.25H5.25ZM12.75 13.5L13.5 12.75H19.5L20.25 13.5V19.5L19.5 20.25H13.5L12.75 19.5V13.5ZM14.25 14.25V18.75H18.75V14.25H14.25Z" fill="#f0f0f4"></path> </g></svg>

			),
		},
		{
			id: `main-menu-2-all`,
			label: 'Jobs',
			path: '/rap-agent/smart-booking/job',
			isEnabled: true,
			svg: (
				<svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<g id="SVGRepo_bgCarrier" stroke-width="0"></g>
					<g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
					<g id="SVGRepo_iconCarrier">
						<path fill-rule="evenodd" clip-rule="evenodd" d="M6 7h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2zm0 2v10h12V9H6zm4-4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v1h-6V5h2zm0 0V4h2v1h-2z" fill="#f0f0f4"></path>
					</g>
				</svg>

			),
		},
		{
			id: `main-menu-2-all`,
			label: 'Vehicle',
			path: '/rap-agent/rap-manager/vehicle',
			isEnabled: true,
			svg: (
				<svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<g id="SVGRepo_bgCarrier" stroke-width="0"></g>
					<g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
					<g id="SVGRepo_iconCarrier">
						<path fill-rule="evenodd" clip-rule="evenodd" d="M5 6h14a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3h-1v1a1 1 0 0 1-2 0v-1H8v1a1 1 0 0 1-2 0v-1H5a3 3 0 0 1-3-3V9a3 3 0 0 1 3-3zm0 2v5h14V8H5zm2 8a1 1 0 1 0 0 2h10a1 1 0 1 0 0-2H7z" fill="#f0f0f4"></path>
					</g>
				</svg>
			),
		}

	])

	menus.map((item) => {
		items.push({ open: true, isActive: false })

	})
	const handleItemClick = (index: any) => {
		setActiveIndex(index === activeIndex ? null : index);
	};
	const handleSubItemClick = (index: any) => {
		setActiveSubIndex(index === activeSubIndex ? null : index);
	};

	const handleSideBarView = () => {
		dispatch(settings.set({ sidebar: !sidebar }))
	}
	const dispatch = useAppDispatch();

	const handleNavigate = (path: any) => {
		navigate(`${path}`)
	}
	const handleLogout = () => {
		logout();
		navigate('/auth/login/transport-agent')
	}
	const handleMenu = (index: any, index1: any) => {
		let menu = [...open]
		open?.map((obj: any, idx: any) => {
			if (idx == index) {
				menu[idx].open = !obj.open
				menu[idx].isActive = true
			}
			else {
				menu[idx].open = true
				menu[idx].isActive = false
			}
		})
		setOpen(menu)
	}
	return (
		<>

			{sidebar ? <div className="w-64 fixed md:top-0 md:left-0 h-screen lg:block bg-primary text-light z-10" >
				{sidebar &&
					<div className={`w-full flex flex-col justify-end items-end p-2 pr-4 mt-20 lg:mt-20 md:mt-20`}>
						<svg
							onClick={() => dispatch(settings.set({ sidebar: !sidebar }))}
							width="22" height="22" viewBox="0 0 24 24" fill="none" className="cursor-pointer hover:stroke-hilight">
							<title>Show Less Infomation</title>
							<path stroke-width="1.25" d="M12.6772 19.5377C12.9742 19.8265 13.449 19.8198 13.7377 19.5228C14.0265 19.2258 14.0198 18.751 13.7228 18.4623L12.6772 19.5377ZM6 12L5.47719 11.4623C5.33195 11.6035 5.25 11.7974 5.25 12C5.25 12.2026 5.33195 12.3965 5.47719 12.5377L6 12ZM13.7228 5.53775C14.0198 5.24901 14.0265 4.77418 13.7377 4.47719C13.449 4.1802 12.9742 4.17351 12.6772 4.46225L13.7228 5.53775ZM17.4772 18.3708C17.7742 18.6595 18.249 18.6528 18.5378 18.3558C18.8265 18.0588 18.8198 17.584 18.5228 17.2952L17.4772 18.3708ZM12 12L11.4772 11.4622C11.332 11.6035 11.25 11.7974 11.25 12C11.25 12.2026 11.332 12.3965 11.4772 12.5378L12 12ZM18.5228 6.70476C18.8198 6.41603 18.8265 5.9412 18.5378 5.64421C18.249 5.34721 17.7742 5.34051 17.4772 5.62924L18.5228 6.70476ZM13.7228 18.4623L6.52281 11.4623L5.47719 12.5377L12.6772 19.5377L13.7228 18.4623ZM6.52281 12.5377L13.7228 5.53775L12.6772 4.46225L5.47719 11.4623L6.52281 12.5377ZM18.5228 17.2952L12.5228 11.4622L11.4772 12.5378L17.4772 18.3708L18.5228 17.2952ZM12.5228 12.5378L18.5228 6.70476L17.4772 5.62924L11.4772 11.4622L12.5228 12.5378Z" fill="#f8f8f8" />
						</svg>
					</div>
				}
				<div className="h-[calc(100vh-10rem)] overflow-auto">
					<div className="mb-4  px-4 h-max ">

						{menus.map((obj: any, index1: any) => {
							return <li
								onClick={() => handleMenu(index1, null)}
								className={`w-full flex flex-col justify-start space-y-3 `}>
								<div onClick={() => handleNavigate(obj?.path)} className={`flex flex-row justify-start rounded-r-lg px-2 cursor-pointer h-10 items-center hover:bg-secondary  hover:text-black" ${open[index1]?.isActive ? "border-l-4 border-blue-500" : ""} `}>
									{obj?.svg}
									<span className="hover:text-black w-36 text-sm ">{obj.label}</span>
								</div>

							</li>
						})}
					</div>
				</div>
			</div> : <div className="w-24 fixed md:top-0 md:left-0 h-screen lg:block bg-primary text-light z-10" >

				<div className="">
					{!sidebar &&
						<div className={`w-full flex flex-col justify-end items-end p-2 mt-20 lg:mt-20 md:mt-20`}>
							<svg
								onClick={() => dispatch(settings.set({ sidebar: !sidebar }))}
								width="22" height="22" viewBox="0 0 24 24" fill="none" className="cursor-pointer hover:stroke-hilight">
								<title>Show More Infomation</title>
								<path stroke-width="1.25" d="M10.2772 18.4623C9.9802 18.751 9.97351 19.2258 10.2623 19.5228C10.551 19.8198 11.0258 19.8265 11.3228 19.5377L10.2772 18.4623ZM18 12L18.5228 12.5377C18.6681 12.3965 18.75 12.2026 18.75 12C18.75 11.7974 18.6681 11.6035 18.5228 11.4623L18 12ZM11.3228 4.46225C11.0258 4.17351 10.551 4.1802 10.2623 4.47719C9.97351 4.77418 9.9802 5.24901 10.2772 5.53775L11.3228 4.46225ZM5.47721 17.2952C5.18021 17.584 5.17351 18.0588 5.46224 18.3558C5.75097 18.6528 6.2258 18.6595 6.52279 18.3708L5.47721 17.2952ZM12 12L12.5228 12.5378C12.668 12.3965 12.75 12.2026 12.75 12C12.75 11.7974 12.668 11.6035 12.5228 11.4622L12 12ZM6.52279 5.62924C6.2258 5.34051 5.75097 5.34721 5.46224 5.64421C5.17351 5.9412 5.18021 6.41603 5.47721 6.70476L6.52279 5.62924ZM11.3228 19.5377L18.5228 12.5377L17.4772 11.4623L10.2772 18.4623L11.3228 19.5377ZM18.5228 11.4623L11.3228 4.46225L10.2772 5.53775L17.4772 12.5377L18.5228 11.4623ZM6.52279 18.3708L12.5228 12.5378L11.4772 11.4622L5.47721 17.2952L6.52279 18.3708ZM12.5228 11.4622L6.52279 5.62924L5.47721 6.70476L11.4772 12.5378L12.5228 11.4622Z" fill="#f8f8f8" />
							</svg>
						</div>
					}
					<div className="mb-4 px-4 h-max ">
						<ul className="w-full flex flex-col justify-start space-y-3">

							{menus.map((barmenu: any, index1: any) => {
								return <li
									className={`flex items-center h-10 ${open[index1]?.isActive ? "border-l-4 border-blue-500" : ""} ${index1 > 7 ? 'hidden' : ""} `}
									onClick={() => handleMenu(index1, null)} >
									<div onClick={() => handleNavigate(barmenu?.path)} className={`flex flex-row justify-start  rounded-lg  px-4  cursor-pointer  h-10 items-center hover:bg-secondary  max-w-24  hover:text-black"`}>
										{barmenu?.svg}
									</div>

								</li>
							})}

						</ul>
					</div>
				</div>
			</div>}


		</>
	)
}

export default TransportAgentSidebar;